module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxMiAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxnIGlkPSJQcm9wZXJ0eSAxPSYjMjI5OyYjMTQzOyYjMTUxOyYjMjI4OyYjMTg4OyYjMTY0OyI+DQo8cmVjdCBpZD0iUmVjdGFuZ2xlIDUxMCIgeD0iMSIgeT0iNC41IiB3aWR0aD0iMTAiIGhlaWdodD0iMyIgcng9IjEiIGZpbGw9IiNFODUwM0EiLz4NCjxyZWN0IGlkPSJSZWN0YW5nbGUgNTExIiB4PSI3LjUiIHk9IjEiIHdpZHRoPSIxMCIgaGVpZ2h0PSIzIiByeD0iMSIgdHJhbnNmb3JtPSJyb3RhdGUoOTAgNy41IDEpIiBmaWxsPSIjRTg1MDNBIi8+DQo8L2c+DQo8L3N2Zz4NCg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/details/event/34.svg
// module id = umMh
// module chunks = 0